import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ErrorState } from '../../../../components/states';
import TeamForm from '../../../../components/forms/TeamForm';
import Loader from '../../../../components/Loader';
import { useFetch } from '../../../../hooks/useFetch';

export default function InstitutionTeamsEditPage() {
  const { itemId } = useParams();

  const { requestApi, data, error } = useFetch(`/v1/admin/teams/${itemId}`);

  useEffect(() => {
    requestApi('get');
  }, []);

  if (error) {
    return <ErrorState onRetry={() => requestApi('get')} />;
  }

  return data?.data ? <TeamForm defaultValues={data?.data} /> : <Loader />;
}
